export class UpTemp {
    file: File;
    name: string;
    progress: number;
    fileID: string;

    constructor(file: File, filedID: string) {
        this.file = file;
        this.fileID = filedID;
    }
}



// WEBPACK FOOTER //
// /zeit/1e2f5901/src/app/upload/upload.ts